import './i18n';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import MainNavigation from './components/common/MainNavigation/MainNavigation';
import MainBody from './components/screens/MainBody/MainBody';
import Projects from './components/screens/Projects/Projects';
import Teams from './components/screens/Teams/Teams';
import RiskCatalog from './components/screens/RiskCatalog/RiskCatalog';
import LedgerJournal from './components/screens/LedgerJournal/LedgerJournal';
import Customers from './components/screens/Customers/Customers';
import Suppliers from './components/screens/Suppliers/Suppliers';
import ProductsAndServices from './components/screens/ProductsAndServices/ProductsAndServices';
import CustomerInvoices from './components/screens/CustomerInvoices/CustomerInvoices';
import SupplierInvoices from './components/screens/SupplierInvoices/SupplierInvoices';
import BankTransactions from './components/screens/BankTransactions/BankTransactions';
import VatReturn from './components/screens/Inspections/VatReturn/VatReturn';
import AnnualStatement from './components/screens/Inspections/AnnualStatement/AnnualStatement';
import ProjectDetails from './components/screens/Projects/ProjectDetails';
import SettingsPage from './components/screens/Settings/SettingsPage';
import AuthGate from './components/screens/Auth/AuthGate';
import TeamDetails from './components/screens/Teams/TeamDetails';
import TimeWriting from './components/screens/TimeWriting/TimeWriting';
import HomeScreen from './components/screens/Home/HomeScreen';
import TaskManagement from './components/screens/TaskManagement/TaskManagement';
import FixedAssets from './components/screens/FixedAssets/FixedAssets';
import YearEndClosing from './components/screens/Inspections/YearEndClosing/YearEndClosing';
import { ToastContainer } from 'react-toastify';


const isElectron = navigator.userAgent.toLowerCase().includes('electron');
const Router = isElectron ? HashRouter : BrowserRouter;

const App: React.FC = () => {
  return (
    <Router>
        <AuthGate>
          <AuthProvider>
            <div className="app-layout">
              <MainNavigation title="Conductor" />
              <MainBody>
                <Routes>
              <Route path="/" element={<HomeScreen />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectDetails />} />
              <Route path="/teams" element={<Teams />} />
              <Route path="/teams/:id" element={<TeamDetails />} />
              <Route path="/risks" element={<RiskCatalog />} />
              <Route path="/ledger-journal" element={<LedgerJournal />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/suppliers" element={<Suppliers />} />
              <Route path="/products-and-services" element={<ProductsAndServices />} />
              <Route path="/customer-invoices" element={<CustomerInvoices />} />
              <Route path="/supplier-invoices" element={<SupplierInvoices />} />
              <Route path="/fixed-assets" element={<FixedAssets />} />
              <Route path="/bank-transactions" element={<BankTransactions />} />
              <Route path="/vat-return" element={<VatReturn />} />
              <Route path="/annual-statement" element={<AnnualStatement />} />
              <Route path="/year-end-closing" element={<YearEndClosing />} />
              <Route path="/time-writing" element={<TimeWriting />} />
              <Route path="/tasks" element={<TaskManagement />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Routes>
            <ToastContainer
              aria-label={'Notification Toasts'}
              position="bottom-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover/>
              </MainBody>
            </div>
          </AuthProvider>
        </AuthGate>
    </Router>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
